import { Directive } from '@angular/core';
import {
  AbstractControl, NG_ASYNC_VALIDATORS, AsyncValidatorFn,
} from '@angular/forms';

export function uniqueDocumentNumberValidator(
documentService: any, orgId: any, type: string, ignoreId?: string): AsyncValidatorFn {
  return (control: AbstractControl): Promise<{[key: string]: any}>  => {
    return new Promise((resolve) => {
      let val = control.value;

      if (val && typeof val.trim !== 'undefined') {
        val = val.trim();
      }

      if (!val) { return resolve(null); }

      documentService.isUniqueNumber(orgId, val, type, ignoreId)
        .subscribe((res: any) => {
          // Changed to this form as it was wrong, value is nested
          return resolve(res.unique ? null : { existingNumber: true });
        });
    });
  };
}

@Directive({
  selector: '[appUniqueDocumentNumber]',
  providers: [{ provide: NG_ASYNC_VALIDATORS,
    useExisting: UniqueDocumentNumberValidatorDirective, multi: true }],
})
export class UniqueDocumentNumberValidatorDirective {
}
